import React from "react";
import { Link } from 'react-router-dom';
import Humanize from 'humanize';
import ReactCountryFlag from "react-country-flag";
import ReactTimeago from "react-timeago";
import { countries } from 'country-data';


class LatestTransactions extends React.Component {

    constructor(props) {
        super(props);
        this.state = { limit: 200 };
    }

    switch = () => { }

    render() {
        const { finances } = this.props;
        const { limit } = this.state;
        const data = finances.latestTransactions;
        const canLoadMore = data && limit < data.length;

        return (
            <div className="card">
                <div className="card-header d-sm-flex align-items-start justify-content-between">
                    <h6 className="lh-5 mg-b-0">Latest Transactions</h6>
                </div>

                <div className="card-body pd-y-15 pd-x-10">
                    <div className="table-responsive table-striped" style={{ maxHeight: 320 }}>
                        <table className="table table-borderless table-sm tx-13 tx-nowrap mg-b-0">
                            <thead>
                                <tr className="tx-10 tx-spacing-1 tx-color-03 tx-uppercase">
                                    <th></th>
                                    <th style={{ paddingLeft: 0 }}>Name</th>
                                    <th>Product</th>
                                    <th>Shekels</th>
                                    <th>Time</th>
                                </tr>
                            </thead>

                            <tbody>
                                {data && data.slice(0, Math.min(limit, data.length)).map(c => <tr key={c.time}>
                                    <td style={{ padding: '5px 5px', width: 20 }}><ReactCountryFlag title={countries[c.country] && countries[c.country].name} countryCode={c.country} svg style={{ fontSize: '1.5em', lineHeight: '1.5em', }} /></td>
                                    <td style={{ paddingLeft: 0 }}><Link to={`/characters/${c.character_id}`}><b style={{ color: c.members ? '#ffa500' : 'auto' }}>{c.name}</b></Link></td>
                                    <td>{iconFor(c.google_id)} {getProductName(c.product_id)}</td>
                                    <td>&euro; {((c.shards / 100.0) * 0.86).toFixed()}</td>
                                    <td><ReactTimeago date={c.time * 1000} /></td>
                                </tr>)}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="card-footer">
                    <button className="btn btn-block btn-dark btn-xs" disabled={!canLoadMore} onClick={() => this.setState({ limit: limit + 10 })}>Load more</button>
                </div>
            </div>
        );
    }

}

const iconFor = (txId) => txId.includes('GPA') ? <IconAndroid /> : <IconApple />;

const IconAndroid = () => (<svg style={{ fill: 'greenyellow' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="16"><path d="M420.6 301.9a24 24 0 1 1 24-24 24 24 0 0 1 -24 24m-265.1 0a24 24 0 1 1 24-24 24 24 0 0 1 -24 24m273.7-144.5 47.9-83a10 10 0 1 0 -17.3-10h0l-48.5 84.1a301.3 301.3 0 0 0 -246.6 0L116.2 64.5a10 10 0 1 0 -17.3 10h0l47.9 83C64.5 202.2 8.2 285.6 0 384H576c-8.2-98.5-64.5-181.8-146.9-226.6" /></svg>);

const IconApple = () => (<svg style={{ fill: 'lightgray' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="16"><path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" /></svg>);

function getProductName(id) {
    switch (id) {
        case 'shards_100': return '100 Shards';
        case 'shards_500': return '500 Shards';
        case 'shards_1500': return '1,500 Shards';
        case 'shards_5000': return '5,000 Shards';

        case 'lamps_5': return '5 Wishes';
        case 'lamps_30': return '30 Wishes';
        case 'lamps_130': return '130 Wishes';
        case 'lamps_500': return '500 Wishes';

        case 'game_membership': return 'Membership';

        default:
            return "<" + id + ">";
    }
}

export default LatestTransactions;
